import { api } from '../../utils/api';
import { type IProduct } from '../../types/IProduct';
import {
  type IGenericResponseRoot,
  CustomError
} from '../../utils/getErrorData';

// улучшенная версия ендпоинта - по возможности использовать её для получения информации о товаре по ID
export const getProductByIdV2 = async (
  productId: number
): Promise<IProduct> => {
  const url = `/admin/product/${productId}`;
  const productResponse = await api.get<IGenericResponseRoot<IProduct>>(url);

  if (productResponse.data.response === null) {
    throw new CustomError(`Товара ${productId} не было найдено`);
  }

  return productResponse.data.response;
};

export const hidingProduct = async (productId: number): Promise<IProduct> => {
  const url = `/admin/product/${productId}`;
  const productResponse = await api.delete<IGenericResponseRoot<IProduct>>(url);

  if (productResponse.data.response === null) {
    throw new CustomError(`Товара ${productId} не было найдено`);
  }

  return productResponse.data.response;
};

export const restoreProduct = async (productId: number): Promise<IProduct> => {
  const url = `/admin/product/${productId}`;
  const productResponse = await api.post<IGenericResponseRoot<IProduct>>(url);

  if (productResponse.data.response === null) {
    throw new CustomError(`Товара ${productId} не было найдено`);
  }

  return productResponse.data.response;
};
